import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, LogOut } from 'lucide-react';

export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const impersonation = localStorage.getItem('inspirotracker_impersonation');
  if (!impersonation) return null;

  let info;
  try { info = JSON.parse(impersonation); } catch { return null; }

  const handleExit = () => {
    const saToken = localStorage.getItem('inspirotracker_sa_backup');
    // Clear impersonation
    localStorage.removeItem('inspirotracker_impersonation');
    localStorage.removeItem('inspirotracker_token');
    localStorage.removeItem('inspirotracker_sa_backup');
    // Restore SA session
    if (saToken) {
      localStorage.setItem('inspirotracker_sa_token', saToken);
    }
    // Navigate back to super admin
    window.location.href = `/superadmin/organizations/${info.orgId}`;
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-amber-950 px-4 py-1.5 flex items-center justify-center gap-3 text-xs font-medium shadow-md" data-testid="impersonation-banner">
      <Eye className="w-3.5 h-3.5 flex-shrink-0" />
      <span>
        Viewing as <strong>{info.adminName}</strong> ({info.adminEmail}) in <strong>{info.orgName}</strong>
      </span>
      <button
        onClick={handleExit}
        className="ml-2 inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-amber-950 text-amber-100 hover:bg-amber-900 transition-colors text-[11px] font-semibold"
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="w-3 h-3" /> Exit
      </button>
    </div>
  );
}
